import * as Reach from '@reach/menu-button';

import {
  STATS_URL,
  DISCORD_URL,
  TWITTER_URL,
  YOUTUBE_URL,
} from '#/routes-external';

import ChevronDownIcon from '#/assets/ChevronDownIcon';
import StatsIcon from '#/assets/StatsIcon';
import DiscordIcon from '#/assets/DiscordIcon';
import TwitterIcon from '#/assets/TwitterIcon';
import YouTubeIcon from '#/assets/YouTubeIcon';

import { useTranslation } from '#/features/localization/utils';

import { NavItemPopoverButtonWithArrow, PopoverMenu } from './PopoverMenu';

export default function MoreMenu() {
  const { t } = useTranslation();

  return (
    <Reach.Menu>
      <Reach.MenuButton as={NavItemPopoverButtonWithArrow}>
        {t('More')} <ChevronDownIcon strokeWidth={2} />
      </Reach.MenuButton>
      <Reach.MenuList as={PopoverMenu}>
        <Reach.MenuLink
          target="_blank"
          rel="noopener noreferrer"
          href={STATS_URL}
        >
          <StatsIcon css="margin-top: -3px" /> {t('Stats')}
        </Reach.MenuLink>
        <Reach.MenuLink
          target="_blank"
          rel="noopener noreferrer"
          href={DISCORD_URL}
        >
          <DiscordIcon /> Discord
        </Reach.MenuLink>
        <Reach.MenuLink
          target="_blank"
          rel="noopener noreferrer"
          href={TWITTER_URL}
        >
          <TwitterIcon /> Twitter
        </Reach.MenuLink>
        <Reach.MenuLink
          target="_blank"
          rel="noopener noreferrer"
          href={YOUTUBE_URL}
        >
          <YouTubeIcon /> YouTube
        </Reach.MenuLink>
      </Reach.MenuList>
    </Reach.Menu>
  );
}
